import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import UserInviteByEmailSF from '../../components/accountUser/UserInviteByEmailSF'
import UserInviteByPhoneSF from '../../components/accountUser/UserInviteByPhoneSF'

const AccountUserInvitePageUI = ({context, messageList}) =>
  <PrivatePageSF context={context} className='pg_acc_usr_inv' backLink='/settings/members'
    messageList={messageList} headerMessageKey='c_invite_user' >
    <PageTitleUI context={context} goBack={true} backLink='/settings/members'
      messageList={messageList} titleMessageKey='c_invite_user' />
    {
      context.session.authMethod === 'email_password' &&
      <UserInviteByEmailSF context={context} messageList={messageList} />
    }
    {
      context.session.authMethod === 'phone_pin' &&
      <UserInviteByPhoneSF context={context} messageList={messageList} />
    }
  </PrivatePageSF>

export default AccountUserInvitePageUI
